<template>
  <div id="orderdetail">
    <h2 class="title">
      <a href="" class="prev"></a>
      订单详情
    </h2>
    <!--地址栏-->
    <a href="">
      <div class="address">
        <p>
          <b class="where">您需要我们送到哪里？</b>
        </p>
        <span class="arrow"></span>
      </div>
    </a>
    <!--订单价格明细-->
    <div class="detail">
      <h3>您的订单价格明细</h3>
      <a>"教师资格笔试取证班"</a>
      <!--商品价格-->
      <div class="price">
        <b>商品价格</b>
        <span>¥270</span>
      </div>
    </div>
    <!--优惠券-->
    <div class="coupon">
      <b>优惠券</b>
      <a href="">
        无可用
        <span class="dot">
          <i></i>
          <i></i>
          <i></i>
        </span>
      </a>
    </div>
    <!--微信-->
    <div class="wxpay">
      <label>
        <b>微信支付</b>
        <input type="radio" name="paytype" checked>
        <span></span>
      </label>
    </div>
    <!--支付宝-->
    <div class="alipay">
      <label>
        <b>支付宝支付</b>
        <input type="radio" name="paytype">
        <span></span>
      </label>
    </div>
    <div class="bg"></div>
    <div class="fix-bar">
      <b>¥270.00</b>
      <div class="discount">已优惠：¥29.00元</div>
      <a href="" class="payfor">马上结算</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDetail'
}
</script>

<style scoped lang="stylus">
#orderdetail
  background-color: #F7F7F7
  .title
    position: relative
    height: 1.08rem
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .32rem
    color: #050505
    font-weight: 500
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: #fff
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #050505
        border-bottom: .03rem solid #050505
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
  .address
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.5rem
    height: 2.24rem
    padding: 0 .4rem
    background-color: #fff
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    p
      b.where
        font-size: .4rem
        color: #050505
        font-weight: 700
    span.arrow
      position: relative
      top: .03rem
      right: .2rem
      display: block
      width: .20rem
      height: .20rem
      border-left: .03rem solid #050505
      border-bottom: .03rem solid #050505
      -webkit-transform: rotate(-135deg)
      -moz-transform: rotate(-135deg)
      -ms-transform: rotate(-135deg)
      -o-transform: rotate(-135deg)
      transform: rotate(-135deg)
  .detail
    width: 7.5rem
    height: 2.92rem
    background-color: #fff
    padding: .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    h3
      margin: .2rem auto
      font-size: .4rem
      color: #333
      text-align: left
    a
      margin: .36rem 0
      font-size: .36rem
      color: #1E81F2
    .price
      display: flex
      justify-content: space-between
      align-items: center
      height: .44rem
      line-height: .44rem
      margin: .26rem 0
      b
        font-size: .32rem
        color: #3D3C45
        font-weight: 400
      span
        font-size: .32rem
        color: #A3A9B7
  .coupon
    display: flex
    justify-content: space-between
    align-items: center
    height: .8rem
    line-height: .8rem
    background-color: #fff
    padding: 0 .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      font-size: .24rem
      color: #333
      font-weight: 400
    a
      font-size: .24rem
      color: #333
      font-weight: 400
      span.dot
        position: relative
        top: -.04rem
        display: inline-flex
        justify-content: space-between
        align-items: center
        width: .3rem
        height: .09rem
        vertical-align: baseline
        margin: 0 .1rem
        i
          display: inline-block
          width: .09rem
          height: .09rem
          background-color: #999
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
          &:nth-of-type(1), &:nth-of-type(3)
            display: inline-block
            width: .06rem
            height: .06rem
            background-color: #D8D8D8
            -webkit-border-radius: 50%
            -moz-border-radius: 50%
            border-radius: 50%
  .wxpay, .alipay
    width: 7.5rem
    height: .8rem
    background-color: #fff
    padding: 0 .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    label
      display: flex
      justify-content: space-between
      align-items: center
      height: 100%
      b
        font-size: .24rem
        color: #333
        &::before
          content: ""
          display: inline-block
          width: .4rem
          height: .4rem
          background: url(../../assets/icon/orderdetail_icon_weixin.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          vertical-align: middle
          margin-right: .2rem
      input
        display: none
      span
        display: inline-block
        width: .4rem
        height: .4rem
        background: url(../../assets/icon/classall_icon_noselect.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
      input:checked + span
        background-image: url(../../assets/icon/classall_icon_tick.png)
  .alipay
    label
      b
        &::before
          background-image: url(../../assets/icon/orderdetail_icon_zhifubao.png)
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background-color: #F7F7F7
  .fix-bar
    position: fixed
    bottom: 0
    left: 0
    display: flex
    justify-content: space-around
    align-items: center
    width: 7.5rem
    height: .98rem
    background-color: #fff
    padding: 0 .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      font-size: .28rem
      color: #FF7052
    .discount
      width: 2.68rem
      height: .98rem
      line-height: .98rem
      background-color: rgba(172,229,255,.12)
      font-size: .24rem
      color: #2BAAFF
      text-align: center
    a.payfor
      display: inline-block
      width: 2.4rem
      height: .72rem
      line-height: .72rem
      /*background-color: #FF7052*/
      background-color: rgba(255,112,82,0.7)
      font-size: .32rem
      color: #fff
      text-align: center
      -webkit-border-radius: .49rem
      -moz-border-radius: .49rem
      border-radius: .49rem
</style>



// WEBPACK FOOTER //
// src/components/order/OrderDetail.vue